import type { DropdownOptionType } from 'components/inputs/Dropdown';

export const descriptionMaxLength = 400;
export const description1000Length = 1000;
export const nameMaxLength = 100;
export const phoneMaxLength = 10;
export const commentsMaxLength = 400;
export const quantityMinNumber = '0';
export const quantityMaxNumber = '100000';
export const priceMinNumber = '0';
export const priceMaxNumber = '100000';
export const defaultPageSize = localStorage.getItem('rowsPerPage') || '50';
export const maxAttachments = 10;
export const ALL_TIME_MIN_DATE = '1900-01-01';
export const ALL_TIME_MAX_DATE = '2100-12-31';

export const countries = [
  { name: 'Afghanistan', code: 'AF' },
  { name: 'land Islands', code: 'AX' },
  { name: 'Albania', code: 'AL' },
  { name: 'Algeria', code: 'DZ' },
  { name: 'American Samoa', code: 'AS' },
  { name: 'AndorrA', code: 'AD' },
  { name: 'Angola', code: 'AO' },
  { name: 'Anguilla', code: 'AI' },
  { name: 'Antarctica', code: 'AQ' },
  { name: 'Antigua and Barbuda', code: 'AG' },
  { name: 'Argentina', code: 'AR' },
  { name: 'Armenia', code: 'AM' },
  { name: 'Aruba', code: 'AW' },
  { name: 'Australia', code: 'AU' },
  { name: 'Austria', code: 'AT' },
  { name: 'Azerbaijan', code: 'AZ' },
  { name: 'Bahamas', code: 'BS' },
  { name: 'Bahrain', code: 'BH' },
  { name: 'Bangladesh', code: 'BD' },
  { name: 'Barbados', code: 'BB' },
  { name: 'Belarus', code: 'BY' },
  { name: 'Belgium', code: 'BE' },
  { name: 'Belize', code: 'BZ' },
  { name: 'Benin', code: 'BJ' },
  { name: 'Bermuda', code: 'BM' },
  { name: 'Bhutan', code: 'BT' },
  { name: 'Bolivia', code: 'BO' },
  { name: 'Bosnia and Herzegovina', code: 'BA' },
  { name: 'Botswana', code: 'BW' },
  { name: 'Bouvet Island', code: 'BV' },
  { name: 'Brazil', code: 'BR' },
  { name: 'British Indian Ocean Territory', code: 'IO' },
  { name: 'Brunei Darussalam', code: 'BN' },
  { name: 'Bulgaria', code: 'BG' },
  { name: 'Burkina Faso', code: 'BF' },
  { name: 'Burundi', code: 'BI' },
  { name: 'Cambodia', code: 'KH' },
  { name: 'Cameroon', code: 'CM' },
  { name: 'Canada', code: 'CA' },
  { name: 'Cape Verde', code: 'CV' },
  { name: 'Cayman Islands', code: 'KY' },
  { name: 'Central African Republic', code: 'CF' },
  { name: 'Chad', code: 'TD' },
  { name: 'Chile', code: 'CL' },
  { name: 'China', code: 'CN' },
  { name: 'Christmas Island', code: 'CX' },
  { name: 'Cocos (Keeling) Islands', code: 'CC' },
  { name: 'Colombia', code: 'CO' },
  { name: 'Comoros', code: 'KM' },
  { name: 'Congo', code: 'CG' },
  { name: 'Congo, The Democratic Republic of the', code: 'CD' },
  { name: 'Cook Islands', code: 'CK' },
  { name: 'Costa Rica', code: 'CR' },
  { name: "Cote D'Ivoire", code: 'CI' },
  { name: 'Croatia', code: 'HR' },
  { name: 'Cuba', code: 'CU' },
  { name: 'Cyprus', code: 'CY' },
  { name: 'Czech Republic', code: 'CZ' },
  { name: 'Denmark', code: 'DK' },
  { name: 'Djibouti', code: 'DJ' },
  { name: 'Dominica', code: 'DM' },
  { name: 'Dominican Republic', code: 'DO' },
  { name: 'Ecuador', code: 'EC' },
  { name: 'Egypt', code: 'EG' },
  { name: 'El Salvador', code: 'SV' },
  { name: 'Equatorial Guinea', code: 'GQ' },
  { name: 'Eritrea', code: 'ER' },
  { name: 'Estonia', code: 'EE' },
  { name: 'Ethiopia', code: 'ET' },
  { name: 'Falkland Islands (Malvinas)', code: 'FK' },
  { name: 'Faroe Islands', code: 'FO' },
  { name: 'Fiji', code: 'FJ' },
  { name: 'Finland', code: 'FI' },
  { name: 'France', code: 'FR' },
  { name: 'French Guiana', code: 'GF' },
  { name: 'French Polynesia', code: 'PF' },
  { name: 'French Southern Territories', code: 'TF' },
  { name: 'Gabon', code: 'GA' },
  { name: 'Gambia', code: 'GM' },
  { name: 'Georgia', code: 'GE' },
  { name: 'Germany', code: 'DE' },
  { name: 'Ghana', code: 'GH' },
  { name: 'Gibraltar', code: 'GI' },
  { name: 'Greece', code: 'GR' },
  { name: 'Greenland', code: 'GL' },
  { name: 'Grenada', code: 'GD' },
  { name: 'Guadeloupe', code: 'GP' },
  { name: 'Guam', code: 'GU' },
  { name: 'Guatemala', code: 'GT' },
  { name: 'Guernsey', code: 'GG' },
  { name: 'Guinea', code: 'GN' },
  { name: 'Guinea-Bissau', code: 'GW' },
  { name: 'Guyana', code: 'GY' },
  { name: 'Haiti', code: 'HT' },
  { name: 'Heard Island and Mcdonald Islands', code: 'HM' },
  { name: 'Holy See (Vatican City State)', code: 'VA' },
  { name: 'Honduras', code: 'HN' },
  { name: 'Hong Kong', code: 'HK' },
  { name: 'Hungary', code: 'HU' },
  { name: 'Iceland', code: 'IS' },
  { name: 'India', code: 'IN' },
  { name: 'Indonesia', code: 'ID' },
  { name: 'Iran, Islamic Republic Of', code: 'IR' },
  { name: 'Iraq', code: 'IQ' },
  { name: 'Ireland', code: 'IE' },
  { name: 'Isle of Man', code: 'IM' },
  { name: 'Israel', code: 'IL' },
  { name: 'Italy', code: 'IT' },
  { name: 'Jamaica', code: 'JM' },
  { name: 'Japan', code: 'JP' },
  { name: 'Jersey', code: 'JE' },
  { name: 'Jordan', code: 'JO' },
  { name: 'Kazakhstan', code: 'KZ' },
  { name: 'Kenya', code: 'KE' },
  { name: 'Kiribati', code: 'KI' },
  { name: "Korea, Democratic People'S Republic of", code: 'KP' },
  { name: 'Korea, Republic of', code: 'KR' },
  { name: 'Kuwait', code: 'KW' },
  { name: 'Kyrgyzstan', code: 'KG' },
  { name: "Lao People'S Democratic Republic", code: 'LA' },
  { name: 'Latvia', code: 'LV' },
  { name: 'Lebanon', code: 'LB' },
  { name: 'Lesotho', code: 'LS' },
  { name: 'Liberia', code: 'LR' },
  { name: 'Libyan Arab Jamahiriya', code: 'LY' },
  { name: 'Liechtenstein', code: 'LI' },
  { name: 'Lithuania', code: 'LT' },
  { name: 'Luxembourg', code: 'LU' },
  { name: 'Macao', code: 'MO' },
  { name: 'Macedonia, The Former Yugoslav Republic of', code: 'MK' },
  { name: 'Madagascar', code: 'MG' },
  { name: 'Malawi', code: 'MW' },
  { name: 'Malaysia', code: 'MY' },
  { name: 'Maldives', code: 'MV' },
  { name: 'Mali', code: 'ML' },
  { name: 'Malta', code: 'MT' },
  { name: 'Marshall Islands', code: 'MH' },
  { name: 'Martinique', code: 'MQ' },
  { name: 'Mauritania', code: 'MR' },
  { name: 'Mauritius', code: 'MU' },
  { name: 'Mayotte', code: 'YT' },
  { name: 'Mexico', code: 'MX' },
  { name: 'Micronesia, Federated States of', code: 'FM' },
  { name: 'Moldova, Republic of', code: 'MD' },
  { name: 'Monaco', code: 'MC' },
  { name: 'Mongolia', code: 'MN' },
  { name: 'Montenegro', code: 'ME' },
  { name: 'Montserrat', code: 'MS' },
  { name: 'Morocco', code: 'MA' },
  { name: 'Mozambique', code: 'MZ' },
  { name: 'Myanmar', code: 'MM' },
  { name: 'Namibia', code: 'NA' },
  { name: 'Nauru', code: 'NR' },
  { name: 'Nepal', code: 'NP' },
  { name: 'Netherlands', code: 'NL' },
  { name: 'Netherlands Antilles', code: 'AN' },
  { name: 'New Caledonia', code: 'NC' },
  { name: 'New Zealand', code: 'NZ' },
  { name: 'Nicaragua', code: 'NI' },
  { name: 'Niger', code: 'NE' },
  { name: 'Nigeria', code: 'NG' },
  { name: 'Niue', code: 'NU' },
  { name: 'Norfolk Island', code: 'NF' },
  { name: 'Northern Mariana Islands', code: 'MP' },
  { name: 'Norway', code: 'NO' },
  { name: 'Oman', code: 'OM' },
  { name: 'Pakistan', code: 'PK' },
  { name: 'Palau', code: 'PW' },
  { name: 'Palestinian Territory, Occupied', code: 'PS' },
  { name: 'Panama', code: 'PA' },
  { name: 'Papua New Guinea', code: 'PG' },
  { name: 'Paraguay', code: 'PY' },
  { name: 'Peru', code: 'PE' },
  { name: 'Philippines', code: 'PH' },
  { name: 'Pitcairn', code: 'PN' },
  { name: 'Poland', code: 'PL' },
  { name: 'Portugal', code: 'PT' },
  { name: 'Puerto Rico', code: 'PR' },
  { name: 'Qatar', code: 'QA' },
  { name: 'Reunion', code: 'RE' },
  { name: 'Romania', code: 'RO' },
  { name: 'Russian Federation', code: 'RU' },
  { name: 'RWANDA', code: 'RW' },
  { name: 'Saint Helena', code: 'SH' },
  { name: 'Saint Kitts and Nevis', code: 'KN' },
  { name: 'Saint Lucia', code: 'LC' },
  { name: 'Saint Pierre and Miquelon', code: 'PM' },
  { name: 'Saint Vincent and the Grenadines', code: 'VC' },
  { name: 'Samoa', code: 'WS' },
  { name: 'San Marino', code: 'SM' },
  { name: 'Sao Tome and Principe', code: 'ST' },
  { name: 'Saudi Arabia', code: 'SA' },
  { name: 'Senegal', code: 'SN' },
  { name: 'Serbia', code: 'RS' },
  { name: 'Seychelles', code: 'SC' },
  { name: 'Sierra Leone', code: 'SL' },
  { name: 'Singapore', code: 'SG' },
  { name: 'Slovakia', code: 'SK' },
  { name: 'Slovenia', code: 'SI' },
  { name: 'Solomon Islands', code: 'SB' },
  { name: 'Somalia', code: 'SO' },
  { name: 'South Africa', code: 'ZA' },
  { name: 'South Georgia and the South Sandwich Islands', code: 'GS' },
  { name: 'Spain', code: 'ES' },
  { name: 'Sri Lanka', code: 'LK' },
  { name: 'Sudan', code: 'SD' },
  { name: 'Suriname', code: 'SR' },
  { name: 'Svalbard and Jan Mayen', code: 'SJ' },
  { name: 'Swaziland', code: 'SZ' },
  { name: 'Sweden', code: 'SE' },
  { name: 'Switzerland', code: 'CH' },
  { name: 'Syrian Arab Republic', code: 'SY' },
  { name: 'Taiwan, Province of China', code: 'TW' },
  { name: 'Tajikistan', code: 'TJ' },
  { name: 'Tanzania, United Republic of', code: 'TZ' },
  { name: 'Thailand', code: 'TH' },
  { name: 'Timor-Leste', code: 'TL' },
  { name: 'Togo', code: 'TG' },
  { name: 'Tokelau', code: 'TK' },
  { name: 'Tonga', code: 'TO' },
  { name: 'Trinidad and Tobago', code: 'TT' },
  { name: 'Tunisia', code: 'TN' },
  { name: 'Turkey', code: 'TR' },
  { name: 'Turkmenistan', code: 'TM' },
  { name: 'Turks and Caicos Islands', code: 'TC' },
  { name: 'Tuvalu', code: 'TV' },
  { name: 'Uganda', code: 'UG' },
  { name: 'Ukraine', code: 'UA' },
  { name: 'United Arab Emirates', code: 'AE' },
  { name: 'United Kingdom', code: 'GB' },
  { name: 'United States', code: 'US' },
  { name: 'United States Minor Outlying Islands', code: 'UM' },
  { name: 'Uruguay', code: 'UY' },
  { name: 'Uzbekistan', code: 'UZ' },
  { name: 'Vanuatu', code: 'VU' },
  { name: 'Venezuela', code: 'VE' },
  { name: 'Viet Nam', code: 'VN' },
  { name: 'Virgin Islands, British', code: 'VG' },
  { name: 'Virgin Islands, U.S.', code: 'VI' },
  { name: 'Wallis and Futuna', code: 'WF' },
  { name: 'Western Sahara', code: 'EH' },
  { name: 'Yemen', code: 'YE' },
  { name: 'Zambia', code: 'ZM' },
  { name: 'Zimbabwe', code: 'ZW' }
];

export const unitOfMeasures: DropdownOptionType[] = [
  { id: 'Pcs', value: 'Pcs' },
  { id: 'Pc', value: 'Pc' },
  { id: 'Ea', value: 'Ea' },
  { id: 'Gallon', value: 'Gallon' },
  { id: 'Quart', value: 'Quart' },
  { id: 'Box', value: 'Box' },
  { id: 'Can', value: 'Can' },
  { id: 'Sheet', value: 'Sheet' },
  { id: '5 gal. bucket', value: '5 gal. bucket' },
  { id: 'Drum', value: 'Drum' },
  { id: 'Kit', value: 'Kit' },
  { id: 'Roll', value: 'Roll' },
  { id: 'Feet', value: 'Feet' },
  { id: 'Bag', value: 'Bag' },
  { id: 'Case', value: 'Case' },
  { id: 'Pack', value: 'Pack' },
  { id: 'Pallet', value: 'Pallet' },
  { id: 'Linear Feet', value: 'Linear Feet' }
];

export const timeOffTypes = [
  {
    id: 'PTO',
    value: 'PTO'
  },
  {
    id: 'Sick',
    value: 'Sick'
  },
  {
    id: 'Bereavement',
    value: 'Bereavement'
  },
  {
    id: 'JuryDuty',
    value: 'Jury Duty'
  },
  {
    id: 'UTO',
    value: 'UTO'
  }
];

export const addOutOfTownHours = '8';

export const timeCardDatePicker = [
  {
    id: '2WeeksAgo',
    value: '2 Weeks Ago'
  },
  {
    id: 'pastWeek',
    value: 'Past Week'
  },
  {
    id: 'currentWeek',
    value: 'Current Week'
  },
  {
    id: 'nextWeek',
    value: 'Next Week'
  },
  {
    id: 'selectDate',
    value: 'Select Date'
  }
];

export enum timeEntryCategory {
  Travel = 'Travel',
  OutOfTown = 'Out Of Town',
  TimeOff = 'Time Off',
  Install = 'Install',
  UnexcusedAbsence = 'Unexcused Absence',
  Holiday = 'Holiday'
}

export enum timeEntrySubCategory {
  PTO = 'PTO',
  Sick = 'Sick',
  Bereavement = 'Bereavement',
  JuryDuty = 'Jury Duty',
  UTO = 'UTO'
}

export const bidTypes = [
  { id: 'Quote', value: 'Quote' },
  { id: 'Pitch', value: 'Pitch' }
];

export const dealSources = [
  { id: 'Previous Customer', value: 'Previous Customer' },
  { id: 'Referral / Word of Mouth', value: 'Referral / Word of Mouth' },
  { id: 'Google Search', value: 'Google Search' },
  { id: 'Google Ads', value: 'Google Ads' },
  { id: 'Social Media', value: 'Social Media' },
  { id: 'Paid Social', value: 'Paid Social' },
  { id: 'Woo', value: 'Woo' },
  { id: 'Trade Show / Event', value: 'Trade Show / Event' },
  { id: 'Contact of Eric Cup', value: 'Contact of Eric Cup' },
  { id: 'Contact of Chris Wilson', value: 'Contact of Chris Wilson' },
  { id: 'Contact of Lisa O’Keefe', value: 'Contact of Lisa O’Keefe' },
  { id: 'Contact of Brian Dressel', value: 'Contact of Brian Dressel' }
];

export const jobTypes = [
  { id: 'CNC Services', value: 'CNC Services' },
  { id: '3D Printing', value: '3D Printing' },
  { id: 'Corporate Interiors', value: 'Corporate Interiors' },
  { id: 'Experiential Marketing', value: 'Experiential Marketing' },
  { id: 'Art Installations', value: 'Art Installations' },
  { id: 'Retail Design', value: 'Retail Design' },
  { id: 'Exhibition Design', value: 'Exhibition Design' },
  { id: 'Installation Only', value: 'Installation Only' },
  { id: 'Software Development', value: 'Software Development' },
  { id: 'Video Content Development', value: 'Video Content Development' },
  { id: 'Hardware Integration', value: 'Hardware Integration' },
  { id: 'Lighting', value: 'Lighting' },
  { id: 'Other', value: 'Other' }
];

export const dealOwners = [{ id: 'oneXerp Admins only', value: 'oneXerp Admins only' }];

export const deliveryAddresses = [
  { id: '4834 S Oakley Ave, Chicago, IL 60609', value: '4834 S Oakley Ave, Chicago, IL 60609' },
  { id: '1719 W 35TH ST, Chicago IL 60609', value: '1719 W 35TH ST, Chicago IL 60609' },
  { id: '1128 N Ashland Ave, Chicago, IL 60622', value: '1128 N Ashland Ave, Chicago, IL 60622' },
  { id: 'Custom Address', value: 'Custom Address' }
];

export const paymentMethods = [
  { id: 'Credit Card', value: 'Credit Card' },
  { id: 'ACH', value: 'ACH' },
  { id: 'Check', value: 'Check' },
  { id: 'Wire', value: 'Wire' },
  { id: 'NET 15', value: 'NET 15' },
  { id: 'NET 30', value: 'NET 30' },
  { id: 'NET 60', value: 'NET 60' }
];

export const paymentStatus: DropdownOptionType[] = [
  { id: 'Not Approved for Payment', value: 'Not Approved for Payment' },
  { id: 'Approved for Payment', value: 'Approved for Payment' },
  { id: 'Paid', value: 'Paid' }
];

export const SHOP_LOCATIONS = [
  {
    id: 'oakley',
    label: 'Oakley Shop',
    address: '4834 S. Oakley Ave, Chicago IL 60609'
  },
  {
    id: '35th',
    label: '35th Shop',
    address: '1719 W. 35th St, Chicago IL 60609'
  },
  {
    id: 'ashland',
    label: 'Ashland Shop',
    address: '1128 N. Ashland Ave, Chicago IL 60622'
  }
];

export const shopLocationOptions: DropdownOptionType[] = [
  { id: '35th Shop', value: '35th Shop' },
  { id: 'Oakley Shop', value: 'Oakley Shop' },
  { id: 'Ashland Shop', value: 'Ashland Shop' }
];

export const orderByList: DropdownOptionType[] = [
  {
    id: 'DESC',
    value: 'Latest First'
  },
  {
    id: 'ASC',
    value: 'Oldest First'
  }
];
